import { useSelector } from 'react-redux';
import Link from 'next/link';

import MenuLogo from '~/src/components/MenuLogo';
import { getCurrentCity } from '~/src/store/selectors/city';

import * as ST from './styled';


export const Logo = () => {
    const city = useSelector(getCurrentCity);

    return <ST.Logo>
        <Link href='/' passHref>
            <MenuLogo href='/' cityData={city}/>
        </Link>
    </ST.Logo>;
};
